import { club, clubPosts, clubs, removeClubPost, reactivateClub, setClubSensitive, suspendClub } from '@/services/club/clubs.service'

let listTicket = 0

export default {
	namespaced: true,
	state: {
		clubs: { data: [], meta: { total: 0 } },
		clubsStatus: 'init',
		club: null,
		posts: [],
		clubStatus: 'init',
		actionStatus: 'init',
	},
	getters: {
		clubs: state => state.clubs,
		clubsStatus: state => state.clubsStatus,
		club: state => state.club,
		posts: state => state.posts,
		clubStatus: state => state.clubStatus,
		actionStatus: state => state.actionStatus,
	},
	mutations: {
		clearDetail(state) {
			state.club = null
			state.posts = []
		},
		setClubs(state, payload) {
			state.clubs = payload
		},
		setClubsStatus(state, status) {
			state.clubsStatus = status
		},
		setClub(state, payload) {
			state.club = payload
		},
		setPosts(state, payload) {
			state.posts = payload
		},
		setClubStatus(state, status) {
			state.clubStatus = status
		},
		setActionStatus(state, status) {
			state.actionStatus = status
		},
	},
	actions: {
		async fetchClubs({ commit }, params) {
			// responses can arrive out of order (page size, search): only the latest request may fill the list
			const ticket = ++listTicket
			commit('setClubsStatus', 'pending')
			try {
				const { data } = await clubs(params)
				if (ticket !== listTicket) return
				commit('setClubs', data)
				commit('setClubsStatus', 'init')
			} catch (e) {
				if (ticket === listTicket) commit('setClubsStatus', 'error')
				throw e
			}
		},
		async fetchClub({ commit }, id) {
			commit('setClubStatus', 'pending')
			try {
				const { data } = await club(id)
				commit('setClub', data.data)
				commit('setClubStatus', 'init')
			} catch (e) {
				commit('setClubStatus', 'error')
				throw e
			}
		},
		async fetchPosts({ commit }, id) {
			const { data } = await clubPosts(id, { per_page: 50 })
			commit('setPosts', data.data)
		},
		async removePost({ commit, dispatch }, { id, uuid, reason }) {
			commit('setActionStatus', 'pending')
			try {
				await removeClubPost({ id, uuid, reason })
			} catch (e) {
				commit('setActionStatus', 'error')
				throw e
			}
			commit('setActionStatus', 'init')
			// the write is done; a failed refresh must not be reported as a failed removal
			await Promise.all([dispatch('fetchPosts', id), dispatch('fetchClub', id)]).catch(() => undefined)
		},
		// One action for the three decisions: they share the status handling and the reload of the detail.
		async decide({ commit, dispatch }, { kind, id, reason, value }) {
			commit('setActionStatus', 'pending')
			try {
				if (kind === 'suspend') await suspendClub({ id, reason })
				else if (kind === 'reactivate') await reactivateClub({ id, reason })
				else await setClubSensitive({ id, value, reason })
			} catch (e) {
				commit('setActionStatus', 'error')
				throw e
			}
			commit('setActionStatus', 'init')
			// the decision is saved; a failed refresh must not make the admin repeat it
			await dispatch('fetchClub', id).catch(() => undefined)
		},
	},
}
